module.exports = __webpack_public_path__ + "static/media/21ECLAC8.3617402d.jpg";